import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FaqService } from 'src/app/services/faq-services/faq.service';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/services/utility-service/utility-service';

import { TooltipPosition } from '@angular/material/tooltip';
import * as es6printJS from "print-js";
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
